import { ChangeDetectorRef, Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { AppService } from 'src/app/service/app.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
declare var $: any;

@Component({
  selector: 'app-menu-mapping',
  templateUrl: './menu-mapping.component.html',
  styleUrls: ['./menu-mapping.component.css']
})
export class MenuMappingComponent {
  submitted = false;
  checked: any;
  verify: any;
  userAccessForm: FormGroup;
  multiSelectMenu: FormGroup;
  accessMapping: FormArray;
  userMenusImpls: FormArray;
  userMenusImpls2: FormArray;
  user: any = {};
  action: string;
  initialValue: string;
  config: any = config;
  menuList: any = [];
  message: string;
  userDetails: any;
  access: any;
  manageAccess: any = [];
  manageAccessData: any;
  menuCode: string = 'useraccess';
  disableManage: boolean = true;
  userControlId: string = '';
  disableField: boolean = false;
  menuListFinal: any = [];
  regId: string = "";
  responseData: any = [];
  registerToken: String = "";

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private appService: AppService,
    private toastr: ToastrService,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private cdref: ChangeDetectorRef) {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.responseData = this.appService.getRegFormByRegID(params['id']);
        this.regId = params['id'];
        // this.action = 'view';
        //  this.setFormData();
      }

      if (params['registerToken']) {
        this.registerToken = params['registerToken'];
      }
    });
  }

  get f() { return this.userAccessForm.controls; }
  get ms() { return this.multiSelectMenu.controls; }

  ngOnInit(): void {
    this.titleService.setTitle('Access Management');
    this.userAccessForm = this.formBuilder.group({
      checked: false,
      verify: false,
      accessMapping: this.formBuilder.array([]),
    });
    this.multiSelectMenu = this.formBuilder.group({
      roleId: [''],
      isAccessAllowed: [''],
      accessType: ['']
    });

    // this.userDetails = this.userDetailsService.getUserDetails();
    // this.access = this.userDetailsService.checkUserAccess(this.menuCode);
    // if (this.access.accessType === "R") {
    // 	this.action = 'view';
    // }
    // if (this.action == 'view' || this.access.roleId == '2') {
    // 	this.disableField = true
    // }
    this.getMemberMenus();
  }

  ngAfterViewInit(): void {
    $('.selectpicker').selectpicker();
  }

  getMemberMenus() {
    this.spinner.show();
    this.appService.getMemberMenus().pipe(
      catchError((error: any) => {
        this.spinner.hide();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        this.spinner.hide();
        this.menuListFinal = response.data[0];
        this.setFormData();
      }
    );
  }

  onSave() {
    // edits the selected menu options
    this.f.accessMapping['controls'].forEach(element => {
      if (element.value.checked) {
        if (this.ms.roleId.value)
          element['controls'].roleId.setValue(this.ms.roleId.value);
        if (this.ms.isAccessAllowed.value)
          element['controls'].isAccessAllowed.setValue(this.ms.isAccessAllowed.value);
        if (this.ms.accessType.value)
          element['controls'].accessType.setValue(this.ms.accessType.value);
        element['controls'].checked.setValue(false);
      }
      if (element.value.userMenusImpls.length > 0) {
        element['controls'].userMenusImpls['controls'].forEach(element1 => {
          if (element1.value.checked) {
            if (this.ms.roleId.value)
              element1['controls'].roleId.setValue(this.ms.roleId.value);
            if (this.ms.isAccessAllowed.value)
              element1['controls'].isAccessAllowed.setValue(this.ms.isAccessAllowed.value);
            if (this.ms.accessType.value)
              element1['controls'].accessType.setValue(this.ms.accessType.value);
            element1['controls'].checked.setValue(false);
          }
          // if (element1.value.userMenusImpls2.length > 0) {
          //   element1['controls'].userMenusImpls2['controls'].forEach(element2 => {
          //     if (element2.value.checked) {
          //       if (this.ms.roleId.value)
          //         element2['controls'].roleId.setValue(this.ms.roleId.value);
          //       if (this.ms.isAccessAllowed.value)
          //         element2['controls'].isAccessAllowed.setValue(this.ms.isAccessAllowed.value);
          //       if (this.ms.accessType.value)
          //         element2['controls'].accessType.setValue(this.ms.accessType.value);
          //       element2['controls'].checked.setValue(false);
          //     }
          //   });
          // }
        });
      }
    });
    this.f.checked.setValue(false);
    $('.selectpicker').selectpicker('refresh');
    this.multiSelectMenu.reset();
  }

  setFormData() {


    let accessMappingControl = <FormArray>this.f.accessMapping;
    this.menuListFinal.forEach((element, index) => {
      let accessType = 'N';
      if (this.responseData?.menuList?.split(",").some(str => str == element.menuCode)) {
        accessType = 'Y';
      }
      accessMappingControl.push(this.formBuilder.group({
        checked: false,
        verify: false,
        userMenuMapId: [element.userMenuMapId],
        userId: [element.userId],
        menuId: [element.menuId],
        menuName: [element.menuName],
        menuCode: [element.menuCode],
        isAccessAllowed: [accessType],
        isActive: [element.isActive],
        isDeleted: [element.isDeleted],
        checkedStatus: [element.checkedBy ? 'approve' : null],
        checkedBy: [element.checkedBy || null],
        checkedDate: [element.checkedDate || null],
        createdBy: [element.createdBy],
        createdDate: [element.createdDate],
        lastModifiedBy: [element.lastModifiedBy],
        lastModifiedDate: [element.lastModifiedDate],
        userMenusImpls: this.formBuilder.array([])
      }));

      if (element.userMenusImpls) {
        element.userMenusImpls.forEach(element1 => {
          let accessType1 = 'N';
          if (this.responseData?.menuList?.split(",").some(str => str == element1.menuCode)) {
            accessType1 = 'Y';
          }
          (accessMappingControl.at(accessMappingControl.length - 1).get('userMenusImpls') as FormArray).push(this.formBuilder.group({
            checked: false,
            verify: false,
            userMenuMapId: [element1.userMenuMapId],
            userId: [element1.userId],
            menuId: [element1.menuId],
            menuName: [element1.menuName],
            menuCode: [element1.menuCode],
            isAccessAllowed: [accessType1],
            isActive: [element1.isActive],
            isDeleted: [element1.isDeleted],
            checkedStatus: [element1.checkedBy ? 'approve' : null],
            checkedBy: [element1.checkedBy || null],
            checkedDate: [element1.checkedDate || null],
            createdBy: [element1.createdBy],
            createdDate: [element1.createdDate],
            lastModifiedBy: [element1.lastModifiedBy],
            lastModifiedDate: [element1.lastModifiedDate],
            userMenusImpls2: this.formBuilder.array([])
          }))

          //   let menuMappingControl = <FormArray>(accessMappingControl.at(accessMappingControl.length - 1).get('userMenusImpls') as FormArray);
          //   if (element1.userMenusImpls) {
          //     element1.userMenusImpls.forEach(element2 => {
          //       (menuMappingControl.at(menuMappingControl.length - 1).get('userMenusImpls2') as FormArray).push(this.formBuilder.group({
          //         checked: false,
          //         verify: false,
          //         userMenuMapId: [element2.userMenuMapId],
          //         userId: [element2.userId],
          //         menuId: [element2.menuId],
          //         menuName: [element2.menuName],
          //         menuCode: [element2.menuCode],
          //         isActive: [element2.isActive],
          //         isDeleted: [element2.isDeleted],
          //         checkedStatus: [element2.checkedBy ? 'approve' : null],
          //         checkedBy: [element2.checkedBy || null],
          //         checkedDate: [element2.checkedDate || null],
          //         createdBy: [element2.createdBy],
          //         createdDate: [element2.createdDate],
          //         lastModifiedBy: [element2.lastModifiedBy],
          //         lastModifiedDate: [element2.lastModifiedDate],
          //       }))
          //     });
          //   }
        });
      }
    });
    this.accessMapping = <FormArray>this.f.accessMapping;
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  onSubmit() {
    let requestObject = { "regId": this.regId, "userMenus": [] };
    this.userAccessForm.getRawValue().accessMapping.forEach((element, index) => {
      if (element.isAccessAllowed == 'Y') {
        requestObject.userMenus.push(element.menuCode);
      }
      if (element.userMenusImpls) {
        element.userMenusImpls.forEach(element1 => {
          if (element1.isAccessAllowed == 'Y') {
            requestObject.userMenus.push(element1.menuCode);
          }
        });
      }
    });

    this.appService.saveMenuList(requestObject).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.cdref.detectChanges();
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.message = 'Menu access requested';
          this.toastr.success(this.message);
          this.router.navigate(['../'], { queryParams: { 'registerToken': this.registerToken}, skipLocationChange: true, relativeTo: this.route });
        } else {
          this.message = response.message;
          this.toastr.error(this.message);
        }
      }
    )
  }

  checkRecordMenu(menuAccess, checkStatus) {
    if (this.responseData.loginID) {
      this.toastr.warning("User is already created. Now you can change access details after login");
      return;
    }
    if (checkStatus == 'approve') {
      menuAccess['controls'].checkedBy.setValue('');
      menuAccess['controls'].checkedDate.setValue(new Date());
      menuAccess['controls'].isAccessAllowed.setValue('Y');
    } else {
      menuAccess['controls'].checkedBy.setValue(null);
      menuAccess['controls'].checkedDate.setValue(null);
      menuAccess['controls'].isAccessAllowed.setValue('N');
    }
    if (menuAccess['controls'].userMenusImpls.length > 0) {
      menuAccess['controls'].userMenusImpls['controls'].forEach(element => {
        if (checkStatus == 'approve') {
          element['controls'].checkedBy.setValue('');
          element['controls'].checkedDate.setValue(new Date());
          element['controls'].isAccessAllowed.setValue('Y');
        } else {
          element['controls'].checkedBy.setValue(null);
          element['controls'].checkedDate.setValue(null);
          element['controls'].isAccessAllowed.setValue('N');
        }
        // if (element['controls'].userMenusImpls2.length > 0) {
        //   element['controls'].userMenusImpls2['controls'].forEach(element1 => {
        //     if (checkStatus == 'approve') {
        //       element1['controls'].checkedBy.setValue(this.userDetails.userId);
        //       element1['controls'].checkedDate.setValue(new Date());
        //       element1['controls'].isActive.setValue('Y');
        //     } else {
        //       element1['controls'].checkedBy.setValue(null);
        //       element1['controls'].checkedDate.setValue(null);
        //       element1['controls'].isActive.setValue('N');
        //     }
        //   });
        // }
      });
    }
  }

  checkRecordSubMenu(menuAccess, subMenuAccess, checkStatus) {
    if (this.responseData.loginID) {
      this.toastr.warning("User is already created. Now you can change access details after login");
      return;
    }
    if (checkStatus == 'approve') {
      menuAccess['controls'].checkedBy.setValue('');
      menuAccess['controls'].checkedDate.setValue(new Date());
      menuAccess['controls'].isAccessAllowed.setValue('Y');
      subMenuAccess['controls'].checkedBy.setValue('');
      subMenuAccess['controls'].checkedDate.setValue(new Date());
      subMenuAccess['controls'].isAccessAllowed.setValue('Y');
    } else {
      subMenuAccess['controls'].checkedBy.setValue(null);
      subMenuAccess['controls'].checkedDate.setValue(null);
      subMenuAccess['controls'].isAccessAllowed.setValue('N');
    }
    // if (subMenuAccess['controls'].userMenusImpls2.length > 0) {
    //   subMenuAccess['controls'].userMenusImpls2['controls'].forEach(element => {
    //     if (checkStatus == 'approve') {
    //       element['controls'].checkedBy.setValue(this.userDetails.userId);
    //       element['controls'].checkedDate.setValue(new Date());
    //       element['controls'].isActive.setValue('Y');
    //     } else {
    //       element['controls'].checkedBy.setValue(null);
    //       element['controls'].checkedDate.setValue(null);
    //       element['controls'].isActive.setValue('N');
    //     }
    //   });
    // }
  }

  // checkRecordSubMenu2(menuAccess, subMenuAccess, subMenuAccess2, checkStatus) {
  //   if (checkStatus == 'approve') {
  //     menuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
  //     menuAccess['controls'].checkedDate.setValue(new Date());
  //     menuAccess['controls'].isActive.setValue('Y');
  //     subMenuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
  //     subMenuAccess['controls'].checkedDate.setValue(new Date());
  //     subMenuAccess['controls'].isActive.setValue('Y');
  //     subMenuAccess2['controls'].checkedBy.setValue(this.userDetails.userId);
  //     subMenuAccess2['controls'].checkedDate.setValue(new Date());
  //     subMenuAccess2['controls'].isActive.setValue('Y');
  //   } else {
  //     subMenuAccess2['controls'].checkedBy.setValue(null);
  //     subMenuAccess2['controls'].checkedDate.setValue(null);
  //     subMenuAccess2['controls'].isActive.setValue('N');
  //   }

  // }

  onVerifyAll() {
    if (this.responseData.loginID) {
      this.toastr.warning("User is already created. Now you can change access details after login");
      return;
    }
    if (this.f.verify.value) {
      this.f.accessMapping['controls'].forEach(menuAccess => {
        this.checkRecordMenu(menuAccess, "approve");
      });
    } else {
      this.f.accessMapping['controls'].forEach(menuAccess => {
        this.checkRecordMenu(menuAccess, "reject");
      });
    }
  }

  requestAccess() {

  }

  cancel() {
    this.router.navigate(['../registeruser'], { queryParams: { 'registerToken': this.registerToken} });
  }
}
